import "./styles.scss";

import { gsap } from "gsap";

class HideFixedBtnOverFooter {
  constructor() {
    this.DOM = { buttons: [...document.querySelectorAll(".fixed-btn")] };
    if(this.DOM.buttons.length === 0 ) return
    this.DOM.trigger = [...document.querySelectorAll(".footer-3col-linknav")];
    this.observer = this.createObserver();
    this.observeTriggers();
  }
  createObserver = () => {
    const options = {
      //   root: null,
      //   threshold: 0,
    };
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          gsap.to(this.DOM.buttons, { autoAlpha: 0 });
        } else {
          gsap.to(this.DOM.buttons, { autoAlpha: 1 });
        }
      });
    };
    return new IntersectionObserver(callback, options);
  };
  observeTriggers = () => {
    this.DOM.trigger.forEach((trigger) => {
      this.observer.observe(trigger);
    });
  };
}

new HideFixedBtnOverFooter();
